export default "__VITE_ASSET__DRSPcs2l__"